import moment from 'moment'
import PropTypes from 'prop-types'

const RegistrationDate = ({ message }) => {
  return (
    <p className="text-sm">
      Joined {moment(message.user.registrationDate).format('MMM DD YYYY')}
    </p>
  )
}

RegistrationDate.propTypes = {
  message: PropTypes.object.isRequired
}

export default RegistrationDate
